import { HIPAGES_HOSTNAME } from './Domains';

const SUPPORT = `support@${HIPAGES_HOSTNAME}`;
export const INFO = `info@${HIPAGES_HOSTNAME}`;

export default {
  SUPPORT,
  INFO
};
